module.exports = __webpack_public_path__ + "media/images/Health-Ready-5b765efeb3f5b18b6ccb2becfaaa6618.svg";